"use client";

// Payment configuration
export const paymentConfig = {
  stripe: {
    publishableKey: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY || "",
  },
  tiptoppay: {
    publicId: process.env.NEXT_PUBLIC_TIPOPPAY_PUBLIC_ID || "",
  },
  yookassa: {
    // YooKassa configuration will be handled through API
  },
};

// API endpoints for payments
export const paymentEndpoints = {
  stripe: {
    createCheckoutSession: "/api/v1/payments/stripe/create-checkout-session",
  },
  yookassa: {
    generateToken: "/api/v1/payments/yookassa/generate_token",
  },
};

// Helper function to get base URL
function getBaseUrl(): string {
  const base = process.env.NEXT_PUBLIC_PROFILE_API_URL;
  if (!base) throw new Error("NEXT_PUBLIC_PROFILE_API_URL is not set");
  return base.replace(/\/$/, "");
}

// Helper function to get auth header
async function getAuthHeader(): Promise<Record<string, string>> {
  const { tokenService } = await import("@/infrastructure/auth/TokenService");
  return tokenService.getAuthHeaders();
}

export { getBaseUrl, getAuthHeader };
